<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>
    <app-list-view [title]="t('common.labels.unit_and_ac_type')" [messages]="messages" [loading]="loading">

      <div buttons>
        <ng-container *ngIf="inEdit !== true">
          <button withRight="admin.planning-settings.show-settings" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-sm p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
          <button *ngIf="models.length > 0" withRight="admin.planning-settings.save-settings-units" pButton (click)="onEdit()" type="button" icon="pi pi-pencil" label="{{ t('common.labels.edit') }}" class="p-button-sm p-ml-2 p-mb-2"></button>
        </ng-container>
        <ng-container *ngIf="inEdit === true">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </ng-container>
      </div>

      <div table>

        <div class="p-grid p-fluid">
          <div class="p-col-6 p-md-2">
            <app-form-control [cid]="'mode'" [control]="form.get('mode')" [type]="'select'" [options]="optionsModes" [showLabel]="false"></app-form-control>
          </div>
          <div class="p-col-6 p-md-2">
            <app-form-control [hidden]="mode !== modes.Businessunits" [cid]="'businessunit'" [control]="form.get('businessunit')" [type]="'group'" [filterBy]="'label'" [options]="optionsBusinessunits" optionLabel="name" [showLabel]="false"></app-form-control>
            <app-form-control [hidden]="mode !== modes.Templates" [cid]="'template'" [control]="form.get('template')" [type]="'select'" [options]="templates" optionLabel="name" [showLabel]="false"></app-form-control>
          </div>
        </div>

        <h2 *ngIf="title !== null" class="p-mt-0 p-mb-4">{{ t('common.labels.settings_for') }} {{ title }}</h2>

        <p-table [value]="models" styleClass="p-datatable-sm" [paginator]="false" [rows]="10000" stateStorage="local" stateKey="template-settings-units-list">
          <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="model.name">{{ t('common.labels.name') }}
                    <p-sortIcon field="model.name"></p-sortIcon>
                </th>
                <th>{{ t('common.labels.active') }}</th>
                <th>{{ t('common.labels.onsite_short') }}</th>
                <th>{{ t('common.labels.virtual') }}</th>
                <th>{{ t('common.labels.own_observer') }}</th>
                <th>{{ t('common.labels.own_observer_gem') }}</th>
                <th>{{ t('common.labels.hiringmanager') }}</th>
                <th>{{ t('common.labels.hr') }}</th>
                <th>{{ t('common.labels.br') }}</th>
                <th>{{ t('common.labels.repr_disabled_persons_short') }}</th>
                <th>{{ t('common.labels.executive_contact') }}</th>
                <th>{{ t('common.labels.postcall') }}</th>
                <th>{{ t('common.labels.stelle') }}</th>
                <th>{{ t('common.labels.monthly_limit_businessunit') }}</th>
                <th>{{ t('common.labels.last_changed') }}</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-model>
              <tr *ngIf="model.model.isheadline === true">
                <td colspan="16"><strong>{{ model.model.name }}</strong></td>
              </tr>
              <tr *ngIf="model.model.isheadline !== true">
                <td>{{ model.model.name }}</td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('active')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control *ngIf="model.form.get('onsite').value !== null" [noMargin]="true" [control]="model.form.get('onsite')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control *ngIf="model.form.get('virtual').value !== null" [noMargin]="true" [control]="model.form.get('virtual')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('own_observer')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('own_observer_gem')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('hiringmanager')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('hr_businesspartner')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('workers_council')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('repr_disabled_persons')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('executive_contact')" [type]="'select'" [options]="options['executive_contact']" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('postcall')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <app-form-control [noMargin]="true" [control]="model.form.get('job')" [type]="'checkbox'" [showLabel]="false"></app-form-control>
                </td>
                <td>
                  <i *ngIf="hasMonthlyLimits(model)" class="pi pi-check p-mr-1"></i>
                  <i *ngIf="!hasMonthlyLimits(model)" class="pi pi-minus p-mr-1" style="opacity: 0.3;"></i>
                  <button *ngIf="inEdit === true" (click)="openMonthlyLimitsDialog(model)" type="button" pButton
                    icon="pi pi-pencil" class="p-button-sm p-button-secondary p-button-outlined ml-1"></button>
                </td>
                <td>
                  {{ model.model.getLastChanged() }}
                </td>
              </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td class="no-data" colspan="17">{{ t('common.labels.no_data') }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </app-list-view>
  </form>

  <p-dialog
    header="{{ t('common.labels.monthly_limits') }} {{ t('common.labels.for') }}: {{ openedEntry?.templateName }} — {{ openedEntry?.businessunitName }}"
    [(visible)]="openedEntry"
    [draggable]="false"
    [resizable]="false"
    modal="true"
    [style]="{width: '50vw'}">

    <ng-container *ngIf="openedEntry">

      <div *ngIf="hasConflictWarning()" role="alert" class="p-messages p-component p-mb-2">
        <div role="alert" class="p-message p-message-warn">
          <div class="p-message-wrapper">
            <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
            <span class="p-message-detail">{{ t('common.labels.monthly_limit_conflict_warning') }}</span>
          </div>
        </div>
      </div>

      <!-- Abschnitt 1: aktueller + 11 zukünftige Monate -->
      <p-table [value]="openedEntry.futureMonths" styleClass="p-datatable-sm" [paginator]="false">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ t('common.labels.month') }}</th>
            <th>{{ t('common.labels.limit') }}</th>
            <th>{{ t('common.labels.booked') }}</th>
            <th>{{ t('common.labels.other_bu_limits') }}</th>
            <th>{{ t('common.labels.template_booked_total') }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entry>
          <tr>
            <td>{{ entry.label }}</td>
            <td>
              <p-inputNumber [formControl]="entry.limit" [showButtons]="false"
                mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" [min]="0"
                placeholder="—" (onBlur)="clampLimitToBooked(entry)"></p-inputNumber>
            </td>
            <td [style.color]="entry.limit.value !== null && entry.booked >= entry.limit.value ? 'red' : null"
                [style.fontWeight]="entry.limit.value !== null && entry.booked >= entry.limit.value ? 'bold' : null">
              {{ entry.booked }}
            </td>
            <td>{{ getOtherBuLimitsLabel(entry.month) }}</td>
            <td [style.color]="hasTemplateLimitConflict(entry.month) ? '#c47b17' : null"
                [style.fontWeight]="hasTemplateLimitConflict(entry.month) ? 'bold' : null">
              {{ getTemplateTotalLabel(entry.month) }}
              <i *ngIf="hasTemplateLimitConflict(entry.month)"
                class="pi pi-exclamation-triangle p-ml-2"></i>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Abschnitt 2: vergangene Monate (aufklappbar) -->
      <div *ngIf="openedEntry.pastMonths.length > 0" class="p-mt-3">
        <button pButton type="button"
          [icon]="showPastMonths ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
          [label]="t('common.labels.past_months')"
          (click)="showPastMonths = !showPastMonths"
          class="p-button-text p-button-secondary p-button-sm"></button>

        <p-table *ngIf="showPastMonths" [value]="openedEntry.pastMonths"
          styleClass="p-datatable-sm" [paginator]="false" class="p-mt-2">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ t('common.labels.month') }}</th>
              <th>{{ t('common.labels.booked_slash_limit') }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-entry>
            <tr>
              <td>{{ entry.label }}</td>
              <td>
                <!-- kein Limit gesetzt -->
                <span *ngIf="entry.originalLimit === null">
                  {{ t('common.labels.booked_count', { booked: entry.booked }) }}
                </span>
                <!-- Limit gesetzt, < 80% -->
                <span *ngIf="entry.originalLimit !== null && entry.booked / entry.originalLimit < 0.8">
                  {{ t('common.labels.booked_of_total', { booked: entry.booked, total: entry.originalLimit }) }}
                </span>
                <!-- ≥ 80% aber noch nicht voll — orange -->
                <span *ngIf="entry.originalLimit !== null && entry.booked / entry.originalLimit >= 0.8 && entry.booked < entry.originalLimit"
                  style="color: orange;">
                  {{ t('common.labels.booked_of_total', { booked: entry.booked, total: entry.originalLimit }) }}
                </span>
                <!-- Limit erreicht — rot -->
                <span *ngIf="entry.originalLimit !== null && entry.booked >= entry.originalLimit"
                  style="color: red;">
                  {{ t('common.labels.booked_of_total', { booked: entry.booked, total: entry.originalLimit }) }}
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </ng-container>

    <p-footer>
      <button pButton (click)="closeMonthlyLimitsDialog()" type="button" [label]="t('common.labels.cancel')"
        class="p-button-outlined p-button-secondary"></button>
      <button pButton (click)="saveMonthlyLimitsDialog()" type="button" [label]="t('common.ok')"
        class="p-button-success"></button>
    </p-footer>
  </p-dialog>

</ng-container>
